import { create } from 'zustand';
import type { Lead } from '../types/leads';

interface LeadStats {
  emailCount: number;
  phoneCount: number;
  processedCount: number;
  totalLeads: number;
  processedPercentage: number;
}

interface LeadStatsStore {
  stats: LeadStats;
  updateStats: (leads: Lead[]) => void;
}

export const useLeadStats = create<LeadStatsStore>((set) => ({
  stats: {
    emailCount: 0,
    phoneCount: 0,
    processedCount: 0,
    totalLeads: 0,
    processedPercentage: 0
  },
  
  updateStats: (leads) => {
    const emailCount = leads.filter(lead => lead.type === 'email').length;
    const phoneCount = leads.filter(lead => lead.type === 'phone').length;
    const processedCount = leads.filter(lead => lead.processed).length;
    const totalLeads = leads.length;
    
    set({
      stats: {
        emailCount,
        phoneCount,
        processedCount,
        totalLeads,
        processedPercentage: totalLeads > 0 
          ? Math.round((processedCount / totalLeads) * 100) 
          : 0
      }
    });
  }
}));